// extracted by mini-css-extract-plugin
export default {"liveNewsMenuText":"XWAvF","inverse":"pAycn","liveNewsMenu":"Qwf7I","bottomMask":"QCKDT","title":"pfefO","line":"dcQIF","row":"_d6M3","itemsContainer":"h16xn","item":"HrX8u"};